import React from 'react'
import { Button, DialogOverlay, DialogOverlayFooter, DialogOverlayActions, DangerButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { ContentDelete } from '@fs/zion-icon'

export default function DeleteOverlay({
  overlay,
  headingText,
  children,
  handleDelete,
  deleteMultipleView = false,
  count = 0,
}) {
  const handleClick = (button) => {
    if (button === 'delete') {
      trackEvent({
        event_name: 'delete_persons_edit',
        link_name: `Delete: Delete`,
      })
      handleDelete()
    } else
      trackEvent({
        event_name: 'click_action',
        link_name: `Delete: Cancel`,
      })
    overlay.close()
  }
  const [t] = useTranslation()

  return (
    <DialogOverlay {...overlay} title={headingText}>
      {children}
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="delete-overlay-cancel-btton" onClick={() => handleClick('cancel')}>
            {t('common-ui:cancel.action', 'Cancel')}
          </Button>
          {deleteMultipleView && (
            <DangerButton
              data-testid="delete-all"
              onClick={() => handleClick('delete')}
              Icon={ContentDelete}
              linkName="Delete Persons Confirmation"
            >
              {t('delete-overlay.delete-all.button_plural', 'Delete ({count})', { count })}
            </DangerButton>
          )}
          {!deleteMultipleView && (
            <DangerButton data-testid="delete" onClick={() => handleClick('delete')}>
              {t('delete-overlay.delete.button', 'Delete')}
            </DangerButton>
          )}
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
